<template>
  <!-- MBR043 Reward detail — member_app_UI/song_fa_members_rewards_catalogue -->
  <div class="page-header align-items-start min-vh-screen mbr-rd">
    <span class="mask bg-white"></span>
    <div class="container p-0" v-if="isShowLayout">
      <header class="mbr-rd__bar">
        <button type="button" class="mbr-rd__back" :aria-label="$t('common.back')" @click="landing()">
          <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" /></svg>
        </button>
        <h1 class="mbr-rd__title">{{ $t('reward.reward') }}</h1>
      </header>

      <main class="mbr-rd__body">
        <section class="mbr-rd__hero">
          <div class="mbr-rd__thumb">
            <img :src="rewardDetail.icon_url" :alt="rewardDetail.reward_title" />
          </div>
          <h2 class="mbr-rd__name">{{ rewardDetail.reward_title ?? "" }}</h2>
          <div class="mbr-rd__cost">
            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path d="M12 8v4l3 3" /></svg>
            <!-- cashback merchants are priced in money, point merchants in points -->
            <span v-if="merchantMember.reward_type == rewardCashback">{{ rewardDetail.amount_text }}</span>
            <span v-else-if="merchantMember.reward_type == rewardPoint">{{ rewardDetail.point_text }}</span>
          </div>
          <p v-if="rewardDetail.expiry_date_text" class="mbr-rd__valid">
            {{ validityText(rewardDetail.expiry_date_text) }}
          </p>
        </section>

        <section v-if="hasApplicability" class="mbr-rd__card">
          <div v-if="rewardDetail.tier_can_exchange_text" class="mbr-rd__row">
            <span class="mbr-rd__icon" aria-hidden="true">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
            </span>
            <p>{{ rewardDetail.tier_can_exchange_text }}</p>
          </div>
          <div v-if="rewardDetail.branch_can_exchange_text" class="mbr-rd__row">
            <span class="mbr-rd__icon" aria-hidden="true">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
            </span>
            <p>{{ rewardDetail.branch_can_exchange_text }}</p>
          </div>
          <div v-if="rewardDetail.item_apply_text" class="mbr-rd__row">
            <span class="mbr-rd__icon" aria-hidden="true">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>
            </span>
            <p>{{ rewardDetail.item_apply_text }}</p>
          </div>
          <div v-if="rewardDetail.order_minimum_text" class="mbr-rd__row">
            <span class="mbr-rd__icon" aria-hidden="true">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            </span>
            <p>{{ rewardDetail.order_minimum_text }}</p>
          </div>
        </section>

        <section v-if="terms.length > 0" class="mbr-rd__card">
          <h3 class="mbr-rd__heading">{{ $t('reward.terms_conditions') }}</h3>
          <ul class="mbr-rd__terms">
            <li v-for="(value, index) in terms" :key="index">{{ value }}</li>
          </ul>
        </section>

        <section v-if="rewardDetail.where_to_use" class="mbr-rd__card">
          <h3 class="mbr-rd__heading">{{ $t('voucher.where_to_use') }}</h3>
          <div class="mbr-rd__where" v-html="rewardDetail.where_to_use"></div>
        </section>
      </main>

      <div v-if="!rewardDetail.is_disabled_btn" class="mbr-rd__cta">
        <button
          type="button"
          class="mbr-rd__exchange"
          data-bs-toggle="modal"
          data-bs-target="#bottom_modal"
        >
          {{ $t('reward.exchange') }}
        </button>
      </div>
    </div>
    <!-- Modal -->
    <Exchange
      :rewardPerTransaction="merchantMember.reward_type ?? 0"
      :voucherData="rewardDetail"
      :amount_format="merchantMember.amount_format" 
      :amount_in_account="merchantMember.amount_in_account" 
      :point_format="rewardDetail.point_text"
      :point_in_account="merchantMember.point"
      :is_disabled="rewardDetail.is_disabled"
      :is_disabled_by_card="rewardDetail.is_disabled_by_card"
      :confirm-exchange="confirmExchange"
    />

    <div class="position-fixed top-1 end-1 z-index-2">
      <material-snackbar v-if="snackbar === 'danger' || snackbar === 'success'" title="" date="" :description="message"
        :icon="{ component: 'campaign', color: 'white' }" :color="snackbar" :close-handler="closeSnackbar" />
    </div>
    <material-loading :active="loaderActive" />
    <ModalConfirm
      :message="$t('reward.confirm_exchange')"
      :btnYes="$t('common.yes')"
      :sycn-profile="processExchange"
    />
    <ModalSuccess :processAcction="gotoMyReward"
      :message="$t('reward.exchange_success')" :buttonText="$t('reward.go_to_my_reward')" />
  </div>

</template>

<script>
import { mapMutations, mapActions } from "vuex";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import RewardService from "../services/reward.service";
import 'bootstrap/dist/js/bootstrap.bundle'
import Exchange from "@/components/Exchange.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import ModalSuccess from "@/components/ModalSuccess.vue";
import $ from "jquery";
import HomeService from "../services/home.service";
import ModalConfirm from "@/components/ModalConfirm.vue";
import { getMerchantCode } from "@/config/utils";
import { validityText } from "@/i18n/apiText";
import { errorMessage } from "@/utils/errorMessage";

export default {
  name: "reward-detail",
  components: {
    MaterialSnackbar,
    Exchange,
    MaterialLoading,
    ModalSuccess,
    ModalConfirm
  },
  data() {
    return {
      rewardDetail: {},
      merchantMember: {},
      loaderActive: false,
      snackbar: null,
      isShowLayout: false,
      merchantCode: "",
      // reward_per_transaction: 1 cashback, 2 point
      rewardCashback: 1,
      rewardPoint: 2,
    };
  },

  computed: {
    // the backend sends full sentences, one per rule; drop the card when none apply
    hasApplicability() {
      return Boolean(
        this.rewardDetail.tier_can_exchange_text ||
        this.rewardDetail.branch_can_exchange_text ||
        this.rewardDetail.item_apply_text ||
        this.rewardDetail.order_minimum_text
      );
    },

    terms() {
      return (this.rewardDetail.terms_arr ?? []).filter(Boolean);
    },
  },
  created() {
    this.getRewardDetail();

    var session_id = this.$route.query.session_id;
      var reward_id = this.$route.query.reward_id;
      if(session_id && reward_id) { // call back after pay success - stripe
        this.showLoader();
        this.isLoadDone = false;
        HomeService.processExchangeByCard(reward_id, session_id).then(
          (response) => {
            if (response.data.result.isSuccess) {
              // const merchantCode = localStorage.getItem('MERCHANT_CODE', '');
              // var url = location.protocol + '//' + location.host+"/"+merchantCode+"/home";
              // window.location.href = url;
              this.getRewardDetail();
              this.snackbar = "success";
              this.message = this.$t('reward.exchange_successfully');
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = errorMessage(response.data.result.message);
              this.setTimeOutNotification();
            }
            this.isLoadDone = true;
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = errorMessage(error);
            this.hideLoader();
          }
        );
      }
  },
  // draws its own back header like the design, same chrome as the catalogue
  beforeMount() {
    this.toggleNavbarOnly();
    this.toggleHideConfig();
    const app = document.querySelector("#app");
    app.classList.add("mbr-sidenav-overlay");
    app.classList.remove("g-sidenav-pinned");
  },

  beforeUnmount() {
    this.toggleNavbarOnly();
    this.toggleHideConfig();
    const app = document.querySelector("#app");
    app.classList.remove("mbr-sidenav-overlay");
    if (window.innerWidth > 1200) {
      app.classList.add("g-sidenav-pinned");
    }
  },

  mounted() {
    const code = getMerchantCode();
    this.merchantCode = code ? `/${code}` : ''
  },
  methods: {
    validityText,
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig", "toggleNavbarOnly"]),
    ...mapActions(["setHeaderColor", "setLabelColor", "setButtonColor"]),

    getRewardDetail() {
      // this.closeSnackbar()
      this.showLoader()
      var rewardId = this.$route.params.reward_id
      RewardService.getRewardDetail(rewardId).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.rewardDetail = response.data.data.reward
            this.merchantMember = response.data.data.merchant_member
            this.isShowLayout = true
          } else {
            this.snackbar = 'danger'
            this.message = errorMessage(response.data.result.message)
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = errorMessage(error)
          this.hideLoader()
        }
      )
    },

    processExchange() {
      $(".btn-close-confirm-modal").click();
      this.closeSnackbar()
      this.showLoader()
      const rewardId = this.rewardDetail.id ?? 0
      RewardService.processExchange(rewardId).then(
        (response) => {
          if (response.data.result.isSuccess) {
            $(".btn-close").click()
            this.getRewardDetail()
            $('.btn-success-modal').click()
          } else {
            $(".btn-close").click()
            this.snackbar = 'danger'
            this.message = errorMessage(response.data.result.message)
            this.setTimeOutNotification()
          }
          this.hideLoader()
        },
        (error) => {
          this.snackbar = 'danger'
          this.message = errorMessage(error)
          this.hideLoader()
        }
      )
    },

    confirmExchange() {
      $(".btn-confirm-modal").click();
    },

    gotoMyReward() {
      $(".btn-close").click()
      this.$router.push(this.merchantCode + '/my-rewards');
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => { this.snackbar = null; }, 3000);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    async landing() {
      $(".btn-close").click()
      this.$router.go(-1)
      // this.$router.push(this.merchantCode + (checkMemberPermissions ? '/reward-catalogue' : '/home'));
    }
  },
};
</script>
<style scoped>
/* MBR043 Reward detail — member_app_UI/song_fa_members_rewards_catalogue.
   The unscoped `.where-to-use a { color: #007BFF }` rule that used to live here is
   dropped (MyRewardDetail.vue keeps a scoped copy, MBR131), and links in this block
   now take the theme colour instead (same call as the MBR036 voucher sheet). */

/* Material Dashboard's `.page-header { overflow: hidden }` would stop the header sticking */
.mbr-rd.page-header {
  overflow: visible;
  overflow-x: clip;
  /* room for the fixed Exchange bar */
  padding-bottom: 112px;
  font-family: var(--mbr-font-body);
}

/* Store.vue still loads an unscoped `* { font-family: Poppins }` app-wide;
   :where() keeps this at one attribute's specificity so the class rules below still win */
.mbr-rd :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-rd .mask {
  background: var(--mbr-color-canvas) !important;
  opacity: 1;
}

.mbr-rd .container {
  max-width: 440px;
  margin: 0 auto;
}

.mbr-rd__bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px 20px 12px;
  background: rgba(var(--mbr-color-canvas-rgb), 0.95);
  border-bottom: 1px solid rgba(var(--mbr-color-outline-rgb), 0.3);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.mbr-rd__back {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-surface);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.7);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-headline);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
  transition: transform 0.12s ease;
}

.mbr-rd__back:active {
  transform: scale(0.95);
}

.mbr-rd__back svg {
  width: 18px;
  height: 18px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-rd__title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  letter-spacing: -0.02em;
  color: var(--mbr-color-ink-headline);
}

.mbr-rd__body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px 20px 0;
}

.mbr-rd__hero {
  padding: 18px;
  background: var(--mbr-color-card);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-lg);
  box-shadow: var(--mbr-shadow-card);
  text-align: center;
}

.mbr-rd__thumb {
  width: 140px;
  aspect-ratio: 1 / 1;
  margin: 0 auto 14px;
  overflow: hidden;
  background: var(--mbr-color-tint);
  border-radius: var(--mbr-radius-md);
}

.mbr-rd__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mbr-rd__name {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 20px;
  font-weight: 800;
  line-height: 26px;
  letter-spacing: -0.015em;
  color: var(--mbr-color-ink-headline);
}

.mbr-rd__cost {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 6px;
  font-family: var(--mbr-font-headline);
  font-size: 16px;
  font-weight: 800;
  line-height: 22px;
  color: var(--mbr-color-primary);
}

.mbr-rd__cost svg {
  flex: none;
  width: 16px;
  height: 16px;
}

.mbr-rd__valid {
  margin: 4px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--mbr-color-ink-muted);
}

.mbr-rd__card {
  padding: 16px;
  background: var(--mbr-color-card);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-lg);
  box-shadow: var(--mbr-shadow-card);
}

.mbr-rd__heading {
  margin: 0 0 10px;
  font-family: var(--mbr-font-headline);
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: normal;
  color: var(--mbr-color-primary);
}

.mbr-rd__row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.mbr-rd__row + .mbr-rd__row {
  margin-top: 12px;
}

.mbr-rd__icon {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: var(--mbr-color-tint);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-primary);
}

.mbr-rd__icon svg {
  width: 15px;
  height: 15px;
}

.mbr-rd__row p {
  margin: 0;
  padding-top: 3px;
  font-size: 13px;
  font-weight: 500;
  line-height: 19px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-rd__terms {
  margin: 0;
  padding-left: 18px;
  list-style: disc;
}

.mbr-rd__terms li {
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-rd__terms li + li {
  margin-top: 6px;
}

.mbr-rd__where {
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-rd__where :deep(p) {
  margin: 0 0 6px;
}

.mbr-rd__where :deep(a) {
  color: var(--mbr-color-primary);
  text-decoration: underline;
}

.mbr-rd__cta {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 25;
  width: 100%;
  padding: 12px 20px calc(16px + env(safe-area-inset-bottom));
  background: rgba(var(--mbr-color-canvas-rgb), 0.95);
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.mbr-rd__exchange {
  display: block;
  width: 100%;
  max-width: 400px;
  height: 48px;
  margin: 0 auto;
  background: var(--mbr-color-primary);
  border: 0;
  border-radius: var(--mbr-radius-full);
  font-family: var(--mbr-font-headline);
  font-size: 15px;
  font-weight: 800;
  color: var(--mbr-color-on-primary);
  box-shadow: var(--mbr-shadow-card);
  transition: transform 0.12s ease;
}

.mbr-rd__exchange:active {
  transform: scale(0.98);
}
</style>
